import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowUpRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("line", { x1: "4", y1: "16", x2: "16", y2: "4", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", "data-color": "color-2" }),
        React.createElement("polyline", { points: "16 11 16 4 9 4", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconArrowUpRight.js.map